
import moment from "moment";
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
const profile = namespace("profile");
const schedule = namespace("schedule");
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
@Component({
  components: {
    Loading,
  },
})
export default class SymphonyOperatingRooms extends Vue {
  @profile.State profileData!: any;

  @Prop() currentEvent: any;

  assignmentLoaded: boolean = false;

  isLoading: boolean = false;
  loaderColor: string = "#0085ca";

  @schedule.State
  public orAssignmentDetail!: any;
  public selectedOR: any = [];

  mounted() {
    this.getORAssignmentDetail();
  }

  getORAssignmentDetail() {
    var payload = {
      username: this.profileData.username,
      date: this.currentEvent.date,
    };

    this.$store
      .dispatch("schedule/getORAssignmentDetails", payload)
      .then(() => {
        //this.isLoaded = true;
        this.assignmentLoaded = true;
        if (this.orAssignmentDetail != null) {
          this.selectedOR = this.orAssignmentDetail[0];
        }
      });
  }

  onRoomChange(selectedObj: any) {
    var selectedShift = this.orAssignmentDetail.find(
      (x) =>
        x.startTime == selectedObj.startTime &&
        x.room == selectedObj.room &&
        x.location == selectedObj.location
    );
    this.selectedOR = selectedShift;
  }
  formatAssignmentTime(date: Date): string {
    return moment(date).format("ddd, MMM D - h:mm A");
  }

  formatDate(date: Date): string {
    return moment(date).format("dddd, MMM DD YYYY");
  }
  formatTime(t: Date): string {
    return moment(t).format("h:mm A");
  }
}
